<div class="empty-cart-dialog__container modal-dialog-centered">
  <div class="modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        {{ 'emptyCart.title' | cxTranslate }}
      </div>
      <button
        type="button"
        class="close"
        aria-describedby="modal-title"
        (click)="dismissModal('Cross click')"
        >
        <span aria-hidden="true">
          <cx-icon [type]="eIconTypes.CLOSE"></cx-icon>
        </span>
      </button>
    </div>

    @if ((getEntries$ | async).length == 0) {
      <div class="cx-dialog-body modal-body">
        <div class="container-fluid">
          {{ "emptyCart.noEntries" | cxTranslate }}
        </div>
      </div>
    } @else {
      @if (!(isDeleting$ | async)) {
        <div class="cx-dialog-body modal-body">
          <div class="container-fluid">
            {{ "emptyCart.deleteAll" | cxTranslate }}
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="removeAllEntries()">
            {{ "emptyCart.yes" | cxTranslate }}
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="dismissModal('Cross click')"
            >
            {{ "emptyCart.no" | cxTranslate }}
          </button>
        </div>
      } @else {
        <div class="cx-dialog-body modal-body">
          <cx-spinner> </cx-spinner>
        </div>
      }
    }


  </div>
